import React from 'react';
import { Outlet } from 'react-router';
import { intersection } from 'lodash-es';
import { useAuth } from '@/hooks/useAuth.ts';
import { ModuleFunction } from '@/features/auth/auth.def.ts';
import { NoPermissionError } from '@/errors/NoPermissionError.ts';

type ProtectedRoutesProps = {
  allowRoles?: string[];
  requiredPermissions?: ModuleFunction[];
};

const EMPTY_ROLES: string[] = [];
const EMPTY_PERMISSIONS: ModuleFunction[] = [];

export const ProtectedRoutes: React.FC<ProtectedRoutesProps> = ({
  allowRoles = EMPTY_ROLES,
  requiredPermissions = EMPTY_PERMISSIONS,
}) => {
  const { checkHasAllPermissions, user } = useAuth();
  const denied =
    (allowRoles.length && !intersection(allowRoles, user?.roles ?? []).length) ||
    !checkHasAllPermissions(requiredPermissions);

  if (denied) throw new NoPermissionError('Access Denied');

  return <Outlet />;
};
